import "./App.css";
import { Routes, Route } from "react-router";
import Dashboard from "../src/dashboard/Dashboard";
import LoginPage from "./Auth/Login";
function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<LoginPage />} />
      </Routes>
      <Routes>
        <Route path="/dashboard/*" element={<Dashboard />} />
      </Routes>
    
    </div>
  );
}

export default App;
